export const MIMES = {
  'video': [
    'video/mp4',
    'video/avi',
    'video/wmv',
    'video/mpg',
    'video/mts',
    'video/flv',
    'video/3gp',
    'video/vob',
    'video/m4v',
    'video/mpeg',
    'video/m2ts',
    'video/mov'
  ],
  'image': [
    'image/jpg',
    'image/jpeg',
    'image/tif',
    'image/psd',
    'image/bmp',
    'image/png',
    'image/nef',
    'image/tiff',
    'image/cr2',
    'image/dwg',
    'image/cdr',
    'image/ai',
    'image/indd',
    'image/pin',
    'image/cdp',
    'image/skp',
    'image/stp',
  ],
  // Allow all format for an attachment
  'attachment': null
  // 'attachment': [
  //   'application/msword',
  //   'application/msword',
  //   'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  //   'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
  //   'application/vnd.ms-word.document.macroEnabled.12',
  //   'application/vnd.ms-word.template.macroEnabled.12',
  //   'application/vnd.ms-excel',
  //   'application/vnd.ms-excel',
  //   'application/vnd.ms-excel',
  //   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  //   'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
  //   'application/vnd.ms-excel.sheet.macroEnabled.12',
  //   'application/vnd.ms-excel.template.macroEnabled.12',
  //   'application/vnd.ms-excel.addin.macroEnabled.12',
  //   'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
  //   'application/vnd.ms-powerpoint',
  //   'application/vnd.ms-powerpoint',
  //   'application/vnd.ms-powerpoint',
  //   'application/vnd.ms-powerpoint',
  //   'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  //   'application/vnd.openxmlformats-officedocument.presentationml.template',
  //   'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
  //   'application/vnd.ms-powerpoint.addin.macroEnabled.12',
  //   'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
  //   'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
  //   'application/vnd.ms-powerpoint.slideshow.macroEnabled.12',
  //   'application/x-gtar',
  //   'application/x-gcompress',
  //   'application/pdf',
  //   'application/compress',
  //   'application/x-tar',
  //   'application/x-rar-compressed',
  //   'application/octet-stream',
  //   'application/x-zip-compressed',
  //   'application/zip-compressed',
  //   'application/x-7z-compressed',
  //   'application/gzip',
  //   'application/x-bzip2',
  //   'doc/doc',
  //   'doc/docx',
  //   'doc/eps',
  //   'doc/txt',
  //   'doc/odt',
  //   'doc/rtf',
  //   'doc/pdf',
  //   'ppt/ppt',
  //   'ppt/pptx',
  //   'ppt/pps',
  //   'ppt/ppsx',
  //   'ppt/odp',
  //   'pdf/pdf'
  // ]
};



// WEBPACK FOOTER //
// ./src/app/vqutils/mimes.ts